import React from 'react';

export default function Card({
  children,
  variant = 'default', // 'default' | 'elevated' | 'glass' | 'outlined'
  className = '',
  ...props
}) {
  const baseStyles = "rounded-xl transition-all duration-300";

  const variantStyles = {
    default: "bg-acem-surface-container border border-acem-border/60 shadow-acem-sm",
    elevated: "bg-white border border-acem-border/40 shadow-acem-md hover:shadow-acem-lg hover:-translate-y-1",
    glass: "bg-white/85 backdrop-blur-md border border-white/60 shadow-acem-md",
    outlined: "bg-acem-surface border border-acem-border hover:border-acem-primary/40",
  };

  return (
    <div className={`${baseStyles} ${variantStyles[variant] || variantStyles.default} ${className}`} {...props}>
      {children}
    </div>
  );
}
